import { render } from "./PSPDFKit.vue?vue&type=template&id=cbca8276&scoped=true"
import script from "./PSPDFKit.vue?vue&type=script&lang=js"
export * from "./PSPDFKit.vue?vue&type=script&lang=js"

import "./PSPDFKit.vue?vue&type=style&index=0&id=cbca8276&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbca8276"]])

export default __exports__